import {
  ContactDetails,
  ContactDetailsValues,
} from "../types/ContactDetailsValues";
import { AssignedRoles } from "../types/ContactDetailRoles";

export const EMPTY_CONTACT_DETAILS_VALUES: ContactDetailsValues = {
  firstName: "",
  lastName: "",
  email: "",
  mobile: "",
  alternatePhone: "",
  businessName: "",
  workContactPreferences: {
    email: false,
    sms: false,
  },
};

export const ASSIGNED_ROLES: AssignedRoles = {
  propertyOwner: false,
  quotePayer: false,
  requester: false,
  siteAccessContact: false,
};

export const EMPTY_CONTACT_DETAILS: ContactDetails = {
  role: "Requester",
  sameAsRole: undefined,
  roles: ASSIGNED_ROLES,
  firstName: "",
  lastName: "",
  email: "",
  mobile: "",
  alternatePhone: "",
  businessName: "",
  workContactPreferences: {
    email: false,
    sms: false,
  },
  quoteContactPreferences: {
    email: true,
    sms: false,
  },
  manualBillingAddress: {
    addressString: "",
    suburb: "",
    city: "",
    postcode: "",
  },
  billingAddressDisplay: "",
  manuallyEnteredBillingAddress: false,
};
